// export const webHost = 'http://192.168.0.112:8000';
export const webHost = "https://api.barakahhijama.com";
export const URI = webHost + "/";
export const URL_API = webHost + "/api/";

export const config = {
  headers: {
    ContentType: 'application/json',
    Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
  },
};

export const IMAGE_URL = "https://api.barakahhijama.com/";
// export const IMAGE_URL = 'http://127.0.0.1:8000/';
// https://api.barakahhijama.com

export const projectname = 'Barakah Hijama'
